export default "__VITE_ASSET__fe7d0150__"